




































































































































































import { Intervention } from "../../models/Intervention";
import { Contact } from "../../models/Contact";
import EEtat = Intervention.EEtat;
import UIActionType = Intervention.UIActionType;
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";
import InterventionAnomalies from "./InterventionAnomalies.vue";

export default {
    name: "InterventionRow",
    components: { InterventionAnomalies, CheckboxInput },
    props: {
        intervention: Intervention,
        showAnomalies: Boolean,
    },
    data() {
        return {
            selected: false,
        };
    },
    computed: {
        isCoproprieteSensible(): boolean {
            return (
                this.intervention.client &&
                this.intervention.client.hasTag(
                    Contact.ETag.CoproprieteSensible
                )
            );
        },
        lineStatusCssClass(): string {
            if (this.intervention.etat_display.id != EEtat.Pending) {
                return this.intervention.etat_display.colorClass;
            } else {
                return "";
            }
        },
        isOngoing(): boolean {
            return this.intervention.etat == EEtat.Ongoing;
        },
    },
    methods: {
        showIntervention() {
            this.$emit(
                "action",
                UIActionType.show_intervention,
                this.intervention
            );
        },
        editIntervention() {
            this.$emit(
                "action",
                UIActionType.edit_intervention,
                this.intervention
            );
        },
        deleteIntervention() {
            this.$emit(
                "action",
                UIActionType.delete_intervention,
                this.intervention
            );
        },
        showNotification() {
            if (this.intervention.notifications.length > 0) {
                this.$emit(
                    "action",
                    UIActionType.show_notification,
                    this.intervention
                );
            }
        },
    },
    watch: {
        intervention: function () {
            this.selected = false;
        },
        selected: function () {
            this.$emit("selected", this.intervention, this.selected);
        },
    },
};
